import { Card, Col, Row } from "reactstrap";
import { MAIN_LEARNING_CARD_DATA } from "../../../../Data/Learning";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { H3, Image, LI, P, UL } from "../../../../AbstractElements";
import { LearningCardsDetails } from "../../../../Constant";


const MainLearningCards = () => {
  return (
    <>
      {MAIN_LEARNING_CARD_DATA.map((data, index) => (
        <Col xl="12" key={index}>
          <Card>
            <Row className="blog-box blog-list ">
              <Col sm="5">
                <Image className="img-fluid sm-100-w" src={dynamicImage(`faq/${index + 1}.jpg`)} alt="blog-image"/>
              </Col>
              <Col sm="7">
                <div className="blog-details">
                  <div className="blog-date"><span>{data.dateSpan}</span> {data.date}</div>
                  <H3 className="mb-1">{data.language}</H3>
                  <div className="blog-bottom-content">
                    <UL className="blog-social simple-list d-flex flex-row">
                      <LI className="rounded-0">by: {data.learningCardBy}</LI>
                      <LI className="digits">{data.hits} Hits</LI>
                    </UL>
                    <hr />
                    <P className="mt-0">{LearningCardsDetails}</P>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default MainLearningCards;
